import type { IPushBridge } from './ports/IPushBridge'
import type { IPushDeviceGateway } from './ports/IPushDeviceGateway'

// Сценарий: после входа записать устройство продавца в notifire (по id и телефону).
// Вызовы идут по очереди, повтор с тем же токеном и владельцем не отправляется: при первом запуске
// вход и новый токен Firebase приходят почти одновременно.
export class RegisterPushDevice {
  #queue: Promise<void> = Promise.resolve()
  #registered = ''

  constructor(
    private readonly bridge: IPushBridge,
    private readonly gateway: IPushDeviceGateway,
  ) {}

  execute(owner: { userId: string, phone: string }, token?: string): Promise<void> {
    const run = this.#queue.then(() => this.#register(owner, token))
    this.#queue = run.catch(() => {})
    return run
  }

  /** Устройство убрано из notifire (выключили пуши): следующий вызов зарегистрирует его снова. */
  reset() {
    this.#registered = ''
  }

  async #register(owner: { userId: string, phone: string }, token?: string) {
    if (!this.bridge.isAvailable()) return
    if (!owner.userId && !owner.phone) return

    const current = await this.bridge.getToken()
    const device = {
      token: token || current.token,
      platform: current.platform,
      userId: owner.userId,
      phone: owner.phone,
    }
    const key = `${device.token}|${device.userId}|${device.phone}`
    if (key === this.#registered) return

    await this.gateway.register(device)
    this.#registered = key
  }
}
